var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { TransparentButton, Box, Text } from "../..";
import { useToggle } from "../../../hooks/useToggle";
import { noop } from "../../../utils";
import { HandleTag } from './';
export var Handle = function (_a) {
    var _b = __read(_a.domain, 2), min = _b[0], max = _b[1], _c = _a.handle, id = _c.id, value = _c.value, percent = _c.percent, disabled = _a.disabled, getHandleProps = _a.getHandleProps, height = _a.height, handleTagDisplay = _a.handleTagDisplay, idPrefix = _a.idPrefix;
    // Using 2 toggle states here to ensure that the tag stays displayed if you are dragging(focused) but not directly hovered.
    var _d = __read(useToggle(false), 2), showTagOnFocus = _d[0], toggleOnFocus = _d[1];
    var _e = __read(useToggle(false), 2), showTagOnMouseOver = _e[0], toggleOnMouseOver = _e[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(TransparentButton, __assign({ type: "button", id: idPrefix ? idPrefix + "-handle-" + id : undefined, lss: {
                left: percent + "%",
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                zIndex: 5,
                width: height * 4,
                height: height * 4,
                cursor: 'pointer'
            } }, getHandleProps(id), { role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, onMouseEnter: handleTagDisplay === 'mouse' ? toggleOnMouseOver : noop, onMouseLeave: handleTagDisplay === 'mouse' ? toggleOnMouseOver : noop, 
            // Would prefer to use onMouseDown/Up here rather than focus, but it hijacks the built-in functioning of the API which udpates the handle positions. any way around this?
            onFocus: handleTagDisplay === 'mouse' ? toggleOnFocus : noop, onBlur: handleTagDisplay === 'mouse' ? toggleOnFocus : noop })),
        React.createElement(Box, { lss: {
                left: percent + "%",
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                zIndex: 2,
                width: height * 4,
                height: height * 4,
                borderRadius: 'rounded',
                boxShadow: 'xs',
                bg: disabled ? 'gray200' : 'white',
                border: 'regular',
                borderColor: disabled ? 'disabled' : 'secondary500'
            } }),
        (handleTagDisplay === 'always' ||
            showTagOnFocus ||
            showTagOnMouseOver) && (React.createElement(HandleTag, { percent: percent, height: height },
            React.createElement(Text, { lss: { textScale: 'control' } }, value)))));
};
//# sourceMappingURL=Handle.js.map